var CallBackOptionSuccessView, CallBackPhoneNumberModel, CommonBaseInputsView, EmailFormDropDownView, EmailFormEmailInputView, EmailFormPhoneNumberInputView, EmailFormRecaptchaView, EmailFormTextLineInputView, EmailFormUserNameInputView, HoldTimeModel, HoldTimeView, PhoneNumberCallBackView, SupportCallMeBackPhoneNumberObjectsTemplate, SupportPhoneNumberWithCallBackTemplate, SupportProgressBarView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportProgressBarView = require('../../progress_bar_view.coffee');

CommonBaseInputsView = require("../../common/views/common_base_inputs_view");

CallBackPhoneNumberModel = require("../../../models/call_back_phone_number_model");

HoldTimeView = require("./hold_time_view");

HoldTimeModel = require("../../../models/hold_time_model");

EmailFormPhoneNumberInputView = require("../../common/views/phone_number_input");

EmailFormEmailInputView = require("../../common/views/email_input_view");

EmailFormDropDownView = require("../../common/views/language_dropdown_input_view");

EmailFormUserNameInputView = require("../INTL/user_name_input_view");

EmailFormTextLineInputView = require("../../common/views/text_line_input_view");

EmailFormRecaptchaView = require("../common/recaptcha_view");

SupportPhoneNumberWithCallBackTemplate = require('../../../../phone_number_with_call_back.html.mustache');

SupportCallMeBackPhoneNumberObjectsTemplate = require('../../../../call_me_back_phone_number_objects.html.mustache');

CallBackOptionSuccessView = require("../common/call_me_back_success_view");

PhoneNumberCallBackView = (function(superClass) {
  extend(PhoneNumberCallBackView, superClass);

  function PhoneNumberCallBackView() {
    this.renderHoldTimePostError = bind(this.renderHoldTimePostError, this);
    this.renderHoldTimePostSuccess = bind(this.renderHoldTimePostSuccess, this);
    return PhoneNumberCallBackView.__super__.constructor.apply(this, arguments);
  }

  PhoneNumberCallBackView.prototype.initialize = function() {
    CommonBaseInputsView.prototype.initialize.apply(this, arguments);
    this.template = SupportPhoneNumberWithCallBackTemplate;
    this.mainView = this.options.mainView;
    this.model = new CallBackPhoneNumberModel();
    this.callBackContainer = $('.help-wizard-content');
    this.inputObjects = this.model.getDefaultPhoneForm().objects;
    this.holdTimeModel = new HoldTimeModel();
    return this.holdTimeView = new HoldTimeView({
      model: this.holdTimeModel
    });
  };

  PhoneNumberCallBackView.prototype.render = function() {
    this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
    this.renderProgressBar();
    this.callBackContainer.html(this.el);
    this.renderInputViews(this.inputObjects, "#call-me-back-inputs");
    this.addAriaLabelToRecaptcha();
    return this.holdTimeView.render();
  };

  PhoneNumberCallBackView.prototype.getViewByObjectType = function(obj) {
    var options;
    options = {
      model: obj,
      validateEmailForm: this.validateEmailForm,
      template: SupportCallMeBackPhoneNumberObjectsTemplate
    };
    switch (obj.type) {
      case 'phone_number':
        return new EmailFormPhoneNumberInputView(options);
      case 'email_address':
        return new EmailFormEmailInputView(options);
      case 'user_name':
        return new EmailFormUserNameInputView(options);
      case 'language_dropDown':
        return new EmailFormDropDownView(options);
      case 'text_description':
        return new EmailFormTextLineInputView(options);
      case 'recaptcha':
        return new EmailFormRecaptchaView(options);
    }
  };

  PhoneNumberCallBackView.prototype.renderNormalPhoneNumberView = function() {
    this.closeModal();
    return this.mainView.renderNormalPhoneNumberView();
  };

  PhoneNumberCallBackView.prototype.onSubmitClick = function() {
    return CommonBaseInputsView.prototype.onSubmitClick.apply(this, arguments);
  };

  PhoneNumberCallBackView.prototype.onLanguageChange = function(event) {
    var locale;
    locale = $("#languageDropdown option:selected").attr("value");
    return this.holdTimeView.updateHoldTime(locale);
  };

  PhoneNumberCallBackView.prototype.addAriaLabelToRecaptcha = function() {
    return $('.g-recaptcha-response').attr("aria-label", "recaptcha");
  };

  PhoneNumberCallBackView.prototype.submitForm = function(data) {
    window.hideDOMElems($('.call-back-phone-number'));
    this.model.postToHoldTime(data, this.renderHoldTimePostSuccess, this.renderHoldTimePostError);
    $(document.createElement('div')).attr('id', 'call-back-final-page-spinner').appendTo('#help-wizard');
    return this.holdTimeView.showLoadingSpinner('#call-back-final-page-spinner', '50px');
  };

  PhoneNumberCallBackView.prototype.enableSubmit = function() {
    $('.call-back-submit-button', this.$el).removeClass('opacity-half');
    return CommonBaseInputsView.prototype.enableSubmit.apply(this, arguments);
  };

  PhoneNumberCallBackView.prototype.disableSubmit = function() {
    $('.call-back-submit-button', this.$el).addClass('opacity-half');
    return CommonBaseInputsView.prototype.disableSubmit.apply(this, arguments);
  };

  PhoneNumberCallBackView.prototype.goToPreviousStep = function() {
    return Groupon.Support.HelpWizardViewManager.renderContactChannels();
  };

  PhoneNumberCallBackView.prototype.getObject = function(type, inputObjects) {
    return _.find(inputObjects, function(object) {
      if (object['model'].type === type) {
        return object;
      }
    });
  };

  PhoneNumberCallBackView.prototype.validateOnFocusOut = function(DomElement, inputObjects) {
    var viewObject;
    if (DomElement.hasClass('call-back-email-input')) {
      viewObject = this.getObject("email_address", inputObjects);
      return viewObject.isInputValid(false);
    } else if (DomElement.hasClass('call-back-phone-number-input')) {
      viewObject = this.getObject("phone_number", inputObjects);
      return viewObject.isInputValid(false);
    }
  };

  PhoneNumberCallBackView.prototype.removeCallBackStepThree = function() {
    var ref;
    return (ref = $('#help-wizard .horizontal')) != null ? ref.remove() : void 0;
  };

  PhoneNumberCallBackView.prototype.renderHoldTimePostSuccess = function(response, locale, userPhoneNumber) {
    this.holdTimeView.hideLoadingSpinner('#call-back-final-page-spinner');
    this.removeCallBackStepThree();
    if (evaluate(response != null ? response.agentNotAvailable : void 0)) {
      return propagateEventBeforeReplacingElements((function(_this) {
        return function() {
          return _this.mainView.callBackErrorHandler(true);
        };
      })(this));
    } else {
      propagateEventBeforeReplacingElements((function(_this) {
        return function() {
          var waitTimeInText;
          waitTimeInText = _this.holdTimeModel.getWaitTimeForLocale(locale);
          _this.callBackSuccessView = new CallBackOptionSuccessView();
          _this.callBackSuccessView.render({
            waitTime: waitTimeInText,
            phone_number: userPhoneNumber
          });
          return $('#help-wizard').append(_this.callBackSuccessView.el);
        };
      })(this));
      return window.hideFooterLinks();
    }
  };

  PhoneNumberCallBackView.prototype.renderHoldTimePostError = function() {
    this.holdTimeView.hideLoadingSpinner('#call-back-final-page-spinner');
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        return _this.mainView.callBackErrorHandler(false);
      };
    })(this));
  };

  PhoneNumberCallBackView.prototype.renderProgressBar = function() {
    var progressBar;
    progressBar = new SupportProgressBarView;
    progressBar.render();
    return this.$el.find('.steps-container').append(progressBar.el);
  };

  PhoneNumberCallBackView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  PhoneNumberCallBackView.prototype.events = {
    'click .close-modal': "closeModal",
    'click .b-close': "closeModal",
    'click .submit-button': 'onSubmitClick',
    'click #back': 'goToPreviousStep',
    'focusin .call-back-inputs': "focusFormInput",
    'focusout .call-back-inputs': "focusoutFormInput",
    'change #languageDropdown': "onLanguageChange"
  };

  return PhoneNumberCallBackView;

})(CommonBaseInputsView);

module.exports = PhoneNumberCallBackView;

//# sourceMappingURL=data:application/json;base64,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
